var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lineBarChart-main"},[(_vm.option.xAxis.data && _vm.option.xAxis.data.length)?_c('basicsChart',{ref:"basicsChart",attrs:{"id":_vm.id,"option":_vm.option}}):_c('div',{staticClass:"no-data-box"},[_c('div',[_vm._v("暂无数据")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }